// navigationService.ts
let _navigate: (to: string, options?: any) => void;

export function setNavigator(n: typeof _navigate) {
  _navigate = n;
}

export function navigate(to: string, options?: any) {
  if (_navigate) {
    _navigate(to, options);
  } else {
    console.warn("Navigator not set yet");
  }
}
